import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { RegistroOnlineComponent } from './components/registro-online/registro-online.component';
import { HomeComponent } from './components/home/home.component';
import { VerificarRegistroComponent } from './components/verificar-registro/verificar-registro.component';
import { SessionComponent } from './components/session/session.component';
import { PerfilComponent } from './components/perfil/perfil.component';
import { FeaturedServicesComponent } from './components/featured-services/featured-services.component';
import { ResetearClaveComponent } from './components/session/resetear-clave/resetear-clave.component';
import { ConfirmarClaveComponent } from './components/session/confirmar-clave/confirmar-clave.component';

const routerOptions: ExtraOptions = {
  useHash: false
  // ...any other options you'd like to use
};

const routes: Routes = [
  {path: '', component: HomeComponent,},
  {path: 'registro-online', component: RegistroOnlineComponent},
  {path: 'verificar-registro/:uuid', component: VerificarRegistroComponent},
  {path: 'login', component: SessionComponent},
  {path: 'cambiar-clave', component: ResetearClaveComponent},
  {path: 'confirmar-clave/:uuid', component: ConfirmarClaveComponent},
  {path: 'perfil', component: PerfilComponent},
  {path: 'featured-services', component: FeaturedServicesComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes,routerOptions)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
